import { useQuery } from '@tanstack/react-query';

import { getCommissionerChannelDataByHandle } from '~/services/commissioner/commissioner-service.service.api';

const STALE_TIME = 30_000;

export const useCommissionerChannelByHandle = ({ handle }: { handle: string }) =>
  useQuery({
    queryKey: ['commissioner/channel', handle],
    queryFn: () => getCommissionerChannelDataByHandle(handle),
    staleTime: STALE_TIME,
    enabled: !!handle,
  });
